import React from 'react'
import Select from 'antd/lib/select'
require('antd/lib/select/style')

const _Select = props => <Select getPopupContainer={trigger => trigger.parentNode} {...props} />
_Select.Option = Select.Option
export default _Select
